import React from "react";
import {
  Image,
  withSitecoreContext,
  RichText,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { SectionListModel } from "./models/SectionList.model";
import { SectionListProps } from "./types/SectionList.types";

const SectionList = (props: SectionListProps) => {
  const model = new SectionListModel(props);
  const getSectionsList = props?.fields?.Sections;
  return (
    <>
      {props?.fields && (
      <div className={`privacy-sections-list text-module--center ${model?.layout?.value}`}>
        {getSectionsList?.map((item, i) => (
          <div key={i} className="privacy-section-item">
            <span className="privacy-item-icon">
              <Image field={item?.fields?.Icon} />
            </span>
            <h2 className="privacy-section-title">
              <RichText field={item?.fields?.Title} />
            </h2>
            <div className="privacy-section-description">
              <RichText field={item?.fields?.BodyText} />
            </div>
            <div className="privacy-section-link">
              {item?.fields?.Link?.value?.anchor ?
                <a href={`${item?.fields?.Link?.value?.href}?${item?.fields?.Link?.value?.querystring}#${item?.fields?.Link?.value?.anchor}`}>
                  {item?.fields?.Link?.value?.text}
                </a>
                :
                <a href={item?.fields?.Link?.value?.href}>
                  {item?.fields?.Link?.value?.text}
                </a>
              }
            </div>
          </div>
        ))}
      </div>
      )}
    </>

  );
};

export default withSitecoreContext()(SectionList);
